import React from 'react'
import SectionBase from './SectionBase'

export default ({ hasCoachProfile }) => (
  <SectionBase
    titleText="Why does booking lessons have to be so hard? With PGA Calendar, reduce the back and forth with your students and become more efficient with your time."
    gtmLearnObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'set-up-calendar',
      onboardingAction: 'click-learn-more',
    }}
    learnMoreLink="https://support.pga.com/en/articles/5541229-pga-calendar-quick-start"
    gtmDoActionObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'set-up-calendar',
      onboardingAction: 'click-get-started',
    }}
    doActionLink={
      hasCoachProfile
        ? '/pga-coach/bookings/schedule'
        : '/pga-coach/bookings/offerings'
    }
    doActionText="Get Started with PGA Schedule"
  />
)
